// extracted by mini-css-extract-plugin
module.exports = {"root":"Style_root__3k5Ow","draggable":"Style_draggable__TrSjU","container":"Style_container__3DLtX","close":"Style_close__2fm4h"};